import { Dispatch, SetStateAction } from 'react';
import { styled } from 'styled-components';

import { Button } from '../Button';
import { CopyContentIcon } from '../../assets/icons';
import { useCopyToClipboard } from '../../utils/useCopyToClipboard';
import { Flex } from '../Layout';
import { Text } from '../Text';
import { Tag } from '../Tag';
import { theme } from '../../styles';

export const CopyToClipBoardButton = ({
  title,
  setClickedIndex,
  ind,
  clickedIndex,
  copyConfirmationText,
}: {
  clickedIndex?: number;
  setClickedIndex?: Dispatch<SetStateAction<number | null>>;
  ind?: number;
  copyConfirmationText: string;
  title: string;
}): JSX.Element => {
  const [copy] = useCopyToClipboard();
  const onClickCopy = () => {
    if (title) {
      copy(title);
    }

    if (setClickedIndex) setClickedIndex(ind ?? null);
  };
  return (
    <Flex justifyContent={'space-between'} flexDirection={['column', 'row']} marginBottom={14}>
      <StyledButton variant="outline" onClick={onClickCopy}>
        {title}
        <Text color="foraBlue" style={{ display: 'flex' }}>
          Kopiera <CopyContentIcon color="foraBlue" width={15} marginLeft={8} />
        </Text>
      </StyledButton>
      {ind === clickedIndex && (
        <TagWrapper>
          <Tag variant="success" text={copyConfirmationText} size="small" />
        </TagWrapper>
      )}
    </Flex>
  );
};

const StyledButton = styled(Button)`
  margin-bottom: 20px;
  gap: 20px;
  height: 50px;
  font-weight: bold;

  @media screen and (min-width: ${theme.breakpoint.md}px) {
    max-width: 260px;
  }
`;

const TagWrapper = styled('div')`
  animation: fadeIn 2s;
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
